import { useGetTermsAndConditions, SendAcceptConsentsForm } from '@pages/auth/hooks';
import { FormCheckboxGroup, Anchor } from '@ui/components';
import { useTranslation, Trans } from 'react-i18next';
import { Control } from 'react-hook-form';
import { FC } from 'react';

interface TermsAndPolicyProps {
  formControl: Control<SendAcceptConsentsForm>;
}

export const TermsAndPolicy: FC<TermsAndPolicyProps> = ({ formControl }) => {
  const { t } = useTranslation();

  const { termsOfServicesBusiness, dataProcessingAgreement, businessWalletTerms } =
    useGetTermsAndConditions();

  return (
    <FormCheckboxGroup
      items={[
        {
          name: 'termsAccepted.accepted',
          label: (
            <Trans
              components={{
                terms: <Anchor href={termsOfServicesBusiness?.url} target="_blank" />,
              }}
              i18nKey="AUTH.ACCEPT_CONSENTS.TERMS_ACCEPTED"
            />
          ),
          required: true,
        },
        {
          name: 'dataProcessingAccepted.accepted',
          label: (
            <Trans
              components={{
                policies: <Anchor href={dataProcessingAgreement?.url} target="_blank" />,
              }}
              i18nKey="AUTH.ACCEPT_CONSENTS.DATA_PROCESSING_ACCEPTED"
            />
          ),
          required: true,
        },
        {
          name: 'walletTermsAccepted.accepted',
          label: (
            <Trans
              components={{
                wallet: <Anchor href={businessWalletTerms?.url} target="_blank" />,
              }}
              i18nKey="AUTH.ACCEPT_CONSENTS.WALLET_TERMS_ACCEPTED"
            />
          ),
          required: true,
        },
        {
          name: 'marketingPhoneManagementAccepted',
          label: t('AUTH.ACCEPT_CONSENTS.MARKETING_PHONE_MANAGEMENT_ACCEPTED'),
        },
        {
          name: 'marketingEmailManagementAccepted',
          label: t('AUTH.ACCEPT_CONSENTS.MARKETING_EMAIL_MANAGEMENT_ACCEPTED'),
        },
      ]}
      formControl={formControl}
    />
  );
};
